export const LS_TOKEN_KEY = 'token';
export const LS_TOKEN_EXPIRES_AT_KEY = 'token-expires-at';
export const LS_TENANT_KEY = 'tenant';
export const LS_CLIENT_TYPE = 'client-type';
export const LS_HAS_LANGUAGE_SCREEN = 'has-language-screen';
export const LS_USER_BLOCKED_AT_PATH = 'user-blocked-at-path';
export const SS_MORE_INFO_SOURCE_TAB = 'more-info-source-tab';
export const SS_BIOMETRIC_CONSENT = 'user-biometric-consent';
export const SS_LAST_ACTIVITY_AT = 'last-activity-at';

export const DOCUMENT_SIGNING_SECONDS = 5 * 60;

export const TIN_LENGTH = {
  usMin: 9,
  usMax: 9,
  otherMin: 8,
  otherMax: 20,
};

export const MINIMUM_SUPPORTED_BROWSER_VERSIONS = {
  Safari: 16,
  SamsungInternet: 25,
  Chrome: 110,
  Edge: 110,
  Firefox: 110,
  Opera: 90,
};

export const BROWSER_HOMEPAGES = {
  Safari: 'https://www.apple.com/safari/',
  SamsungInternet:
    'https://www.samsung.com/us/support/owners/app/samsung-internet',
  Chrome: 'https://www.google.com/chrome/',
  Edge: 'https://www.microsoft.com/edge',
  Firefox: 'https://www.mozilla.org/firefox/',
  Opera: 'https://www.opera.com/',
};

export const BROWSER_APPSTORE = {
  Safari: 'https://apps.apple.com/us/app/safari/id1146562112',
  Chrome: 'https://apps.apple.com/us/app/google-chrome/id535886823',
  Edge: 'https://apps.apple.com/us/app/microsoft-edge-ai-browser/id1288723196',
  Firefox:
    'https://apps.apple.com/us/app/firefox-private-web-browser/id989804926',
  Opera: 'https://apps.apple.com/us/app/opera-ai-browser-with-vpn/id1411869974',
};

export const BROWSER_PLAYSTORE = {
  SamsungInternet:
    'https://play.google.com/store/apps/details?id=com.sec.android.app.sbrowser',
  Chrome: 'https://play.google.com/store/apps/details?id=com.android.chrome',
  Edge: 'https://play.google.com/store/apps/details?id=com.microsoft.emmx',
  Firefox: 'https://play.google.com/store/apps/details?id=org.mozilla.firefox',
  Opera: 'https://play.google.com/store/apps/details?id=com.opera.browser',
};
